"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var default_1 = require("./default");
exports.Default = default_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/node-vibrant/lib/generator/index.js
// module id = 590
// module chunks = 23899280101116